import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { useLeadModal } from "../../context/LeadModalContext";

export function MobileCTA() {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);
  const { openLeadForm } = useLeadModal();

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 480);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (pathname !== "/") return null;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-3 bottom-3 z-40 lg:hidden"
        >
          <button
            data-testid="mobile-sticky-cta"
            onClick={() => openLeadForm("mobile_sticky_cta")}
            className="w-full rounded-full bg-gold py-4 font-display text-sm font-bold text-forest-deep shadow-[0_10px_35px_rgba(212,175,55,0.5)]"
          >
            Book a Free Strategy Call
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
